// removed by extract-text-webpack-plugin
module.exports = {"navigation":"src-components----navigation-module---navigation---_yI7y","navigationItem":"src-components----navigation-module---navigationItem---1plNx"};


//////////////////
// WEBPACK FOOTER
// ./src/components/navigation.module.css
// module id = 369
// module chunks = 114276838955818